import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../utils/axiosInstance";
import apiConfig from "../config/appConfig";

const useAuth = () => {
  const [user, setUser] = useState(() => {
    const token = localStorage.getItem("token");
    const storedUser = localStorage.getItem("user");
    return token && storedUser ? JSON.parse(storedUser) : null; // Parse stored user if available
  });
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const login = async (username, password) => {
    try {
      const response = await axiosInstance.post(
        apiConfig.endpoints.auth.login,
        { username, password },
      );
      const token = response.data.token;
      const userData = response.data.user; // Assuming `user` object is returned from the API
      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(userData)); // Store user data in localStorage
      setUser({ token, ...userData }); // Save user data in state
      setError(null);
      navigate("/dashboard");
    } catch (err) {
      setError(err.response?.data?.message || "An unexpected error occurred.");
    }
  };

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
    navigate("/");
  };

  const isAuthenticated = !!user;

  return { login, logout, isAuthenticated, error, user }; // Return the `user` object
};

export default useAuth;
